import React from 'react';
import { Switch as SwitchBase } from '@gravity-ui/uikit';
import { block } from '../../../utils';
import './Switch.css';
const b = block('switch');
export const Switch = ({ name, input, spec }) => {
    const { value, onBlur, onChange, onFocus } = input;
    const handleChange = React.useCallback((e) => onChange(e.target.checked), [onChange]);
    return (React.createElement(SwitchBase, { checked: value, onChange: handleChange, onBlur: onBlur, onFocus: onFocus, disabled: spec.viewSpec.disabled, className: b(), qa: name }));
};
